import { exists } from '@/api'
import { SearchType } from '@/types'

export interface BatchReserveCollectionListCondition {
  reserveNumFrom: string
  reserveNumTo: string
  holdingNumFrom: string
  holdingNumTo: string
  orderNumFrom: string
  orderNumTo: string
  searchType: SearchType[]
  outputOrder: string
}

export function BatchReserveCollectionListConditionFromJSON(
  json: any
): BatchReserveCollectionListCondition {
  const _json = JSON.parse(json)

  return {
    reserveNumFrom: exists(_json, 'reserve_num_from')
      ? String(_json.reserve_num_from)
      : '',
    reserveNumTo: exists(_json, 'reserve_num_to')
      ? String(_json.reserve_num_to)
      : '',
    holdingNumFrom: exists(_json, 'holding_num_from')
      ? String(_json.holding_num_from)
      : '',
    holdingNumTo: exists(_json, 'holding_num_to')
      ? String(_json.holding_num_to)
      : '',
    orderNumFrom: exists(_json, 'order_num_from')
      ? String(_json.order_num_from)
      : '',
    orderNumTo: exists(_json, 'order_num_to') ? String(_json.order_num_to) : '',
    searchType: exists(_json, 'search_type') ? _json.search_type : [],
    outputOrder: exists(_json, 'output_order') ? _json.output_order : '1'
  }
}
